import React from 'react';
import Close from '@crehana/icons/dist/CloseSmallOutline';
import cn from 'classnames';

import FilterChips from '../FilterChips';

interface Props {
  title: string;
  showFilters?: boolean;
  closeDialog: () => void;
}

const DrawerMobileContent: React.FC<Props> = ({
  children,
  title,
  showFilters,
  closeDialog,
}) => {
  const [isEmptyFilters, setIsEmptyFilters] = React.useState(true);

  return (
    <>
      <div
        className={cn('sticky top-0 left-0 bg-white z-7', {
          'p-16': !showFilters,
          'px-16 py-12': showFilters,
        })}
      >
        <button
          type="button"
          onClick={closeDialog}
          className="max-h-24 max-w-24"
        >
          <Close
            size={24}
            ignoreColor
            className="fill-current text-base-dark min-w-24"
          />
        </button>

        {showFilters && (
          <FilterChips
            onFiltersChange={total => {
              setIsEmptyFilters(total === 0);
            }}
          />
        )}
        {(!showFilters || isEmptyFilters) && (
          <div className="uppercase text-gray-dark font-label mt-16">
            {title}
          </div>
        )}
      </div>

      {children}
    </>
  );
};

export default DrawerMobileContent;
